<template>
  <div class="configurator-modal-market-government">
    <div>
      <div class="pt-4 pb-4">
        <img src="@/assets/products/product-goshawk-u8-rgb.png" alt="GOSHAWK u8" width="250px">
      </div>
      <table class="table is-bordered is-fullwidth">
        <thead class="has-background-white-ter">
          <tr>
            <th>
              <span>SPECIFICATION*</span>
            </th>
            <th>
              <span>GEO-LTE</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>
                <span>Antenna type</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span
                  >Full duplex, single aperture, Ku-band flat-panel antenna,<br />electronically
                  steered holographic beamforming array</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Scan angles</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>Azimuth: 360°, Elevation: +15° to +90°</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Polarization</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>Linear, software-defined</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Receive (RX) band</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>10.70 G</span><span>H</span><span>z to 12.75 G</span
                ><span>H</span><span>z</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>RX performance</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>G/T (broadside) 9.5 dB/K to 12 dB/K</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Transmit (TX) band</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>13.75 G</span><span>H</span><span>z to 14.50 G</span
                ><span>H</span><span>z</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>TX performance</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>EIRP (broadside) 46 dBW to 46.5 dBW</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Cross-pol isolation</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>≥25 dB</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Satellite modem</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>Embedded iDirect 950mp</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Cellular modem</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span
                  >600 Mbps (CAT 12)<br />(Global or North America and public
                  safety configurations)</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Interfaces</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>Ethernet &amp; Wi-Fi (802.11 b/g/n)</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Dimensions</span>
              </p>
            </td>
            <td>
              <p class="cell-data ParaOverride-3">
                <span
                  >L 89.5 cm × W 89.5 cm × H 14 cm / L 35.2 in. × W 35.2 in. × H
                  5.5 in.</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Weight</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>34 kg (75 lb.)</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Input power**</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>12 VDC to 36 VDC max</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Power (typical, steady state)***</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>130 W</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Operational temperature</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span
                  >-40 °C to +55 °C (ambient) / -40 °C to +70 °C (with solar
                  load)</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Storage temperature</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>-40 °C to +85 °C</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Ingress protection</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>IP66</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>Compliance</span>
              </p>
            </td>
            <td>
              <p class="cell-data">
                <span>CE, FCC, N</span><span>emko</span><span>, WEEE, R</span
                ><span>o</span><span>HS, S</span><span>alt</span><span> </span
                ><span>fog</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pt-4">
      <p>
        <span>*Specifications as of 19 May 2022. Subject to change.</span>
      </p>
      <p>
        <span>**AC input support available via accessory.</span>
      </p>
      <p>
        <span>
          ***Software-controlled peak power draw. User-configurable to a higher
          threshold for very low-temperature operation.
        </span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  setup() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.configurator-modal-market-government {
}
</style>
